<div class="agm-container">
  <agm-map [latitude]="polygonData.ZonePaths[0][0].lat" [longitude]="polygonData.ZonePaths[0][0].lng" 
           [zoom]="mapZoom" [mapTypeId]="mapType">
      
    <agm-polygon [fillColor]="polygonData.fillColor" [fillOpacity]="polygonData.fillOpacity" 
       [polyDraggable]="false" *ngFor="let polygon of allGeofenceDetails" [paths]="polygon" 
       [hidden]="createPolygon" [clickable]="true">

       <agm-info-window [isOpen]="info" [latitude]="polygon[0].lat" [longitude]="polygon[0].lng" #infoWindow>
        <div class="card" style="width: 18rem;">
          <div class="card-body">
            <h5 class="card-title">{{filterGeofenceName(polygon[0].geofenceId)}}</h5>
          </div>
          <ul class="list-group list-group-flush"> {{getAllZoneIdsByGeofenceId(polygon[0].geofenceId)}}
            <li class="list-group-item" *ngFor="let zone of zoneList">{{getZoneNameByZoneId(zone)}}</li>
          </ul>
        </div>
      </agm-info-window>

    </agm-polygon> 
    
  </agm-map>

  <select class="form-control bg-dark text-white select-l"  #mySelect
      (change)='wt(mySelect.value)'  [(ngModel)]="mapType">
      <option value="terrain">Map</option>
      <option value="satellite">Satellite</option>     
  </select>

  <br />
  <input type="text" class="search-l form-control" id="pac-input" placeholder="Search Map" />
</div>

